import { useCallback, useEffect, useRef } from 'react'

/**
 * Wie `usePendingRestore`, aber für mehrere: Aufgaben auswählen, sobald ALLE in der Liste
 * stehen — herausgelöste Unteraufgaben kommen erst mit dem nächsten Abgleich dorthin (#204).
 */
export function usePendingSelection(
  visibleIds: readonly string[],
  select: (ids: string[]) => void,
): (ids: string[]) => void {
  const pendingRef = useRef<string[] | null>(null)
  const selectRef = useRef(select)
  selectRef.current = select

  useEffect(() => {
    const ids = pendingRef.current
    if (!ids || !ids.every(id => visibleIds.includes(id))) return
    pendingRef.current = null
    selectRef.current(ids)
  }, [visibleIds])

  return useCallback((ids: string[]) => {
    pendingRef.current = ids.length > 0 ? ids : null
  }, [])
}
